import React, { useEffect, useState } from 'react';
import { format, parse } from 'date-fns';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import ListPage from '../../../sharedModules/listPage/ListPage';
import axios from '../../../sharedModules/utils/axios.utils';
import { SelectOption } from '../../../sharedModules/form/model';

const formatSortTime = (value: string | null | undefined): string => {
  if (!value) return '';
  try {
    const date = parse(value, 'HH:mm:ss', new Date());
    return format(date, 'h:mm a');
  } catch {
    return value;
  }
};

const statusConfig: Record<string, { label: string; color: 'default' | 'primary' | 'success' | 'warning' | 'info' }> = {
  Open: { label: 'Open', color: 'primary' },
  Contacted: { label: 'Contacted', color: 'info' },
  ReadyInv: { label: 'Ready to Invoice', color: 'warning' },
  Review: { label: 'Review', color: 'warning' },
  Completed: { label: 'Completed', color: 'success' },
};

const getStatusChip = (status: string) => {
  const config = statusConfig[status] || { label: status, color: 'default' as const };
  return <Chip label={config.label} color={config.color} size="small" variant="outlined" />;
};

const jobColumns = [
  {
    name: 'Time',
    selector: 'sort_time',
    sortable: true,
    grow: 0.5,
    format: (row: { sort_time?: string | null }) => formatSortTime(row.sort_time),
  },
  {
    name: 'Customer',
    selector: 'customer_name',
    sortable: true,
    grow: 1.25,
  },
  {
    name: 'Technician',
    selector: 'emp_id',
    sortable: true,
    grow: 1,
  },
  {
    name: 'Order #',
    selector: 'order_no',
    sortable: true,
    grow: 0.75,
  },
  {
    name: 'Status',
    selector: 'status',
    sortable: true,
    grow: 0.75,
    cell: (row: { status?: string }) => getStatusChip(row.status || ''),
  },
];

const clearFilterSetting = {
  customer_name_i_cont: '',
  order_no_i_cont: '',
  emp_id_eq: '',
};

const UpcomingJobsPage: React.FC = () => {
  const [technicianOptions, setTechnicianOptions] = useState<SelectOption[]>([]);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response: any = await axios.get('/home_services/inspection_jobs/new');
        setTechnicianOptions(response.data.technician_options || []);
      } catch {}
    };
    fetchOptions();
  }, []);

  const jobFilters = [
    {
      label: 'Technician',
      type: 'select',
      param: 'emp_id_eq',
      choices: technicianOptions,
      width: 2,
    },
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        <ListPage
          clickableRows
          clearedFilterSetting={clearFilterSetting}
          columns={jobColumns}
          controller="home_services/inspection_jobs"
          defaultFilters={{}}
          defaultSort="sort_time asc"
          filterDefinitions={jobFilters}
          includeFilterBar
          queryPlaceholder="Search by Customer or Order #"
          title="Home Services"
          subtitle={`Today's Inspections (${format(new Date(), 'MM/dd/yyyy')})`}
          rowClickPath="home_services/upcoming_inspections"
        />
      </Grid>
    </Grid>
  );
};

export default UpcomingJobsPage;
